import { render, staticRenderFns } from "./QuickTipsSearchPerson.vue?vue&type=template&id=d0d49ee6&"
import script from "./QuickTipsSearchPerson.vue?vue&type=script&lang=js&"
export * from "./QuickTipsSearchPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports